/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UpdateCounterService {
    /**
     * Read Update Counter News
     * @param lastLogin
     * @param areaOfInterestId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static readUpdateCounterNewsUpdateCounterBlogGet(
        lastLogin: string,
        areaOfInterestId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/update_counter/blog',
            query: {
                'last_login': lastLogin,
                'area_of_interest_id': areaOfInterestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Update Counter Bulletins
     * @param lastLogin
     * @param areaOfInterestId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static readUpdateCounterBulletinsUpdateCounterBulletinGet(
        lastLogin: string,
        areaOfInterestId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/update_counter/bulletin',
            query: {
                'last_login': lastLogin,
                'area_of_interest_id': areaOfInterestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Update Counter Transfers
     * @param lastLogin
     * @param areaOfInterestId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static readUpdateCounterTransfersUpdateCounterTransferGet(
        lastLogin: string,
        areaOfInterestId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/update_counter/transfer',
            query: {
                'last_login': lastLogin,
                'area_of_interest_id': areaOfInterestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Update Counter Feed
     * @param lastLogin
     * @param areaOfInterestId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static readUpdateCounterFeedUpdateCounterFeedGet(
        lastLogin: string,
        areaOfInterestId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/update_counter/feed',
            query: {
                'last_login': lastLogin,
                'area_of_interest_id': areaOfInterestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
